export const WDS_EE_WIDGET_MAP = {
  WDS_AI_CHAT_WIDGET: "WDS_AI_CHAT_WIDGET",
  WDS_ANVIL_TABLE_WIDGET: "WDS_ANVIL_TABLE_WIDGET",
};
